<script>
  // 개인정보 처리방침 정적 콘텐츠 페이지
</script>

<section class="policy-container">
  <h1>개인정보처리방침</h1>

  <p>
    E-RION 앱(이하 "회사" 또는 "본 서비스")은 이용자의 개인정보를 중요시하며, 「개인정보 보호법」 및 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 대한민국의 관련 법령을 준수합니다. 본 개인정보처리방침은 이용자가 본 서비스를 이용하면서 제공하는 개인정보가 어떠한 방법과 목적으로 수집·이용되고 있으며, 이용자의 개인정보를 보호하기 위해 회사가 어떠한 조치를 취하고 있는지 설명합니다. 아울러 이용자의 권리와 그 행사 방법을 안내드립니다.
  </p>

  <h2>1. 수집하는 개인정보 항목</h2>
  <p>회사는 서비스 제공을 위해 필요 최소한의 개인정보만을 수집합니다. 수집되는 주요 개인정보 항목은 다음과 같습니다.</p>
  <dl>
    <dt>구글 계정 정보</dt>
    <dd>구글 로그인 연동을 위해 이용자의 Google 프로필에서 제공받는 정보로서, 이름, 이메일 주소, 프로필 사진(선택사항)이 해당됩니다. 이는 로그인 및 계정 관리를 위해 필수적인 정보입니다.</dd>

    <dt>서비스 이용 정보</dt>
    <dd>앱 사용 과정에서 자동으로 생성되고 수집될 수 있는 정보로, 기기 정보(운영체제, 버전), 접속 IP 주소, 방문 일시, 사용 로그 등이 있습니다. 이러한 정보는 서비스 최적화 및 오류 로그 분석을 위해 활용될 수 있습니다.</dd>

    <dt>사진 및 이미지 정보</dt>
    <dd>이용자가 업로드하는 반려견 사진 이미지 파일 자체와 그에 대한 메타데이터(촬영 일시, 기기 정보 등 포함될 수 있음)가 수집됩니다. 해당 이미지는 AI를 통해 스타일 변환 및 편집 서비스를 제공하는 데 사용됩니다.</dd>

    <dt>결제 정보</dt>
    <dd>유료 서비스 결제 시 결제를 위해 필요한 신용카드 정보, 결제 기록 등의 정보를 추가로 수집합니다.</dd>
  </dl>
  <p>이외에도 고객문의나 이벤트 참여 등 추가적인 상황에서 필요 시 별도의 정보를 수집할 수 있으며, 그 경우 수집 시점에 이용자에게 사전 동의를 구합니다.</p>

  <h2>2. 개인정보의 수집 및 이용 목적</h2>
  <p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다. 수집된 정보는 명시한 목적 이외의 용도로는 이용되지 않으며, 목적 변경 시에는 사전에 이용자의 동의를 받겠습니다.</p>
  <dl>
    <dt>서비스 제공 및 운영</dt>
    <dd>이용자의 신원을 확인하고 개인화된 서비스를 제공하기 위해 구글 계정 정보를 사용합니다. 이를 통해 로그인 상태를 유지하고 이용자의 편집 결과물, 설정 등을 계정에 연동하여 제공할 수 있습니다. 또한 업로드된 반려견 사진은 AI 알고리즘을 통해 이미지를 스타일 변환/편집하는 핵심 기능 제공을 위해 이용됩니다.</dd>

    <dt>고객 지원 및 의사소통</dt>
    <dd>이용자가 문의사항을 남기거나 문제가 발생했을 때 원활히 대응하기 위해 이용자의 연락처(이메일 등)를 활용할 수 있습니다. 또한 서비스 변경, 약관 및 정책 개정 등의 중요한 고지는 앱 내 알림이나 이메일을 통해 안내하기 위한 목적으로 이메일 주소를 사용할 수 있습니다.</dd>

    <dt>서비스 품질 향상 및 연구 개발</dt>
    <dd>이용 패턴, 오류 로그 등의 서비스 이용 정보를 분석하여 서비스 성능을 개선하고 신규 기능을 개발하는 데 활용합니다. 예를 들어, 어떤 필터 기능이 인기있는지 통계를 내어 더 나은 필터를 개발하는 참고 자료로 삼습니다. 이때에도 분석 목적의 데이터는 가능하면 익명화하거나 통계 형태로 처리하여 사용합니다.</dd>

    <dt>보안 및 부정이용 방지</dt>
    <dd>IP주소, 기기정보 등은 부정 사용 방지나 보안 모니터링을 위해 사용될 수 있습니다. 비정상적인 서비스 접근이나 해킹 시도를 탐지하고 차단하는 데 도움이 됩니다.</dd>

    <dt>법령 준수</dt>
    <dd>법적 의무를 이행하거나 정부 기관의 적법한 요구에 대응하기 위해 필요한 경우 관련 정보를 이용할 수 있습니다. 예를 들어, 수사 목적으로 법령에 따라 자료 제공 요청이 있는 경우 해당 범위 내에서 정보를 활용할 수 있습니다.</dd>
  </dl>

  <h2>3. 개인정보 보유 및 이용 기간</h2>
  <dl>
    <dt>계정 정보(이름, 이메일 등)</dt>
    <dd>이용자가 서비스를 이용하는 동안 안전하게 보유하며, 회원 탈퇴를 요청하거나 동의 철회를 하는 경우 관련 법령에 따라 즉시 또는 일정 기간 내 파기합니다. 단, 회원 탈퇴 후에도 부정 이용 방지, 법적 분쟁 대비 등을 위해 아이디(이메일) 등의 최소한의 정보는 내부 방침에 따라 최대 1년간 보관할 수 있으며, 그 이후에는 해당 정보를 완전히 삭제하거나 별도 분리 보관합니다.</dd>

    <dt>서비스 이용 로그, 기기 정보</dt>
    <dd>이러한 정보는 수집일로부터 최대 1년간 보관하며, 분석 목적이 달성되면 순차적으로 삭제하거나 통계자료로만 보관됩니다. 법령에 특별한 보존 의무가 없는 한, 1년 초과 시 개인을 식별할 수 없도록 익명화하거나 파기합니다.</dd>

    <dt>업로드한 사진 파일</dt>
    <dd>이용자의 반려견 사진 원본과 편집 결과물은 서비스를 제공하기 위한 기간 동안만 저장됩니다. 편집 처리가 완료된 후 90일이 지나면 원본 및 결과 사진을 서버에서 삭제합니다. 이는 이용자가 편집 결과를 재다운로드하거나 이력을 확인할 수 있도록 한시적으로 보관하는 기간이며, 해당 기간 경과 후에는 이미지를 복구할 수 없도록 완전 삭제합니다.</dd>
  </dl>
  <h3>관련 법령에 따른 보존</h3>
  <ul>
    <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
    <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
    <li>로그 기록 등 본 서비스 접속에 관한 기록: 3개월 (통신비밀보호법)</li>
  </ul>
  <p>위 보유 기간이 경과한 개인정보는 복구 불가능한 방법으로 안전하게 파기합니다. 전자적 파일 형태는 복구할 수 없도록 영구 삭제하며, 종이 출력물은 분쇄하거나 소각합니다.</p>

  <h2>4. 개인정보의 제3자 제공</h2>
  <p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다음의 경우를 제외하고는 이용자의 개인정보를 외부에 공개하거나 제공하지 않습니다.</p>
  <dl>
    <dt>이용자가 별도로 제3자 제공에 동의한 경우</dt>
    <dd>특정 서비스를 위해 이용자가 동의를 제공한 경우 해당 범위 내에서 개인정보가 제3자와 공유될 수 있습니다. (예: 이벤트 응모를 위해 제휴사에 정보 제공 동의를 받은 경우 등)</dd>

    <dt>법령에 의한 요구가 있는 경우</dt>
    <dd>수사 목적으로 법령에서 정해진 절차와 방법에 따라 수사기관이 정보 제공을 요구할 경우, 해당 법적 요건을 충족하는 범위 내에서 개인정보를 제공할 수 있습니다. 이 경우에도 관련 법령을 엄격히 준수하여 최소한의 정보만 제공하도록 합니다.</dd>

    <dt>긴급한 생명∙신체의 위험 등 정당한 필요가 있는 경우</dt>
    <dd>이용자 또는 타인의 생명, 신체, 재산에 대한 급박한 위험이 발생하여 긴급하게 개인정보 제공이 필요한 때에는 법령에 따라 개인정보를 제공할 수 있습니다.</dd>
  </dl>
  <p>회사는 위의 경우를 제외하고 이용자의 개인정보를 외부에 판매하거나 임의로 공유하지 않습니다. 특히 광고주나 기타 서비스 제공자에게 이용자의 직접 식별이 가능한 정보를 제공하지 않습니다.</p>

  <h2>5. 개인정보 보호를 위한 기술적∙관리적 조치 (보안조치)</h2>
  <dl>
    <dt>데이터 암호화</dt>
    <dd>이용자의 개인정보는 암호화된 통신 구간(SSL/TLS 등)을 통해 전송되며, 비밀번호와 같이 중요한 데이터는 별도의 암호화 기술을 적용하여 저장합니다. 특히, Google 로그인을 통한 인증 과정에서는 OAuth 프로토콜을 사용하여 이용자의 비밀번호를 저장하거나 직접 취급하지 않습니다.</dd>

    <dt>방화벽 및 접근 통제</dt>
    <dd>회사는 외부로부터의 무단 접근을 차단하기 위해 방화벽(Firewall) 등 보안 시스템을 운영하고 있습니다. 또한 개인정보에 대한 접근 권한을 최소한의 담당자에게만 부여하며, 중요 데이터는 별도의 권한 인증 절차를 거쳐서만 접근할 수 있도록 관리합니다.</dd>

    <dt>접속 기록의 보관 및 점검</dt>
    <dd>개인정보처리시스템에 접속한 기록을 법령에 따라 최소 6개월 이상 보관하며, 접속 기록이 위변조 또는 도난, 분실되지 않도록 별도로 백업하고 관리합니다. 정기적으로 접속 기록을 점검하여 불법적인 접근 시도를 모니터링합니다.</dd>
  </dl>
  <p>회사는 이러한 노력을 통해 이용자의 개인정보가 안전하게 관리되도록 최선을 다하고 있으며, 만약 개인정보 유출 등의 사고가 발생할 경우 지체 없이 사실을 알리고 필요한 조치를 취할 것입니다.</p>

  <h2>6. 이용자의 권리</h2>
  <dl>
    <dt>동의 철회 및 서비스 탈퇴</dt>
    <dd>이용자는 개인정보의 수집·이용에 대한 동의를 언제든지 철회할 수 있으며, 서비스 탈퇴(회원 탈퇴)를 요청할 권리가 있습니다. 앱의 회원 탈퇴 기능을 이용하거나 고객센터를 통해 탈퇴 의사를 밝히면, 회사는 본인 확인 후 관련 법령에서 정한 절차에 따라 계정 탈퇴를 처리합니다.</dd>

    <dt>권리 행사 방법</dt>
    <dd>상기 권리 행사는 앱 내 제공되는 기능을 통해서 하실 수 있으며, 해당 기능이 없는 경우 본 방침 하단의 연락처를 통해 서면, 이메일 등의 방법으로 요청할 수 있습니다. 회사는 요청을 받은 날로부터 10일 이내에 조치를 완료하고 결과를 알려드릴 것입니다.</dd>
  </dl>

  <h2>7. 개인정보 문의 및 연락처</h2>
  <h3>개인정보 보호 책임자</h3>
  <p>
    이름: 김수한 <br>
    직책: 기술연구소 사원<br>
    연락처: suhan1029@wenit.co.kr
  </p>
  <p>
    이용자는 서비스를 이용하시면서 발생하는 모든 개인정보 보호 관련 문의, 불만 처리, 피해구제 등에 관한 사항을 개인정보 보호 책임자 및 담당부서로 문의할 수 있습니다. 회사는 이용자의 문의에 대해 신속하고 충분한 답변을 드릴 것입니다. 또한 개인정보와 관련하여 도움이 필요한 경우 대한민국의 공식 기관인 개인정보침해신고센터 (국번없이 118), 대검찰청 사이버수사과 (국번없이 1301), 경찰청 사이버안전국 (국번없이 182) 등에 문의하실 수 있습니다.
  </p>

  <h2>8. 개인정보처리방침의 변경</h2>
  <p>
    법령, 정책 또는 보안 기술의 변경에 따라 본 개인정보처리방침의 내용이 수정될 수 있습니다. 개인정보처리방침을 개정하는 경우 변경 사항을 앱 초기 화면이나 설정 메뉴 등을 통해 사전에 공지하고, 필요한 경우 이용자의 동의를 다시 받을 수도 있습니다. 본 방침의 하단에 최신 개정 날짜를 명시하여 이용자가 개정 여부를 쉽게 확인할 수 있도록 합니다. 개정된 방침은 공지하거나 통지한 시행 일자부터 효력이 발생합니다.
  </p>

  <h3>부칙</h3>
  <p>이 개인정보처리방침은 2025년 9월 25일부터 적용됩니다. 이전의 개인정보 처리방침은 본 방침으로 대체됩니다.</p>
</section>

<style>
  .policy-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 1rem;
    line-height: 1.7;
    word-break: keep-all;
  }
  h1 {
    margin: 0 0 1rem 0;
    font-size: 1.8rem;
  }
  h2 {
    margin-top: 2rem;
    font-size: 1.2rem;
  }
  h3 {
    margin-top: 1rem;
    font-size: 1rem;
  }
  dl {
    margin: 0.8rem 0;
  }
  dt {
    font-weight: 600;
    margin-top: 0.6rem;
  }
  dd {
    margin: 0.3rem 0 0.6rem 0;
  }
  ul {
    padding-left: 1.1rem;
  }
  p {
    margin: 0.6rem 0;
  }
</style>
